import React from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
const FullViewModal = ({ containerClass, children, showModal, hideModal,...rest }) => {
  const { t } = useTranslation(['workpermit', 'util']);
  return (
    <Modal centered show={showModal} className={containerClass} onHide={hideModal} {...rest}>
      <Modal.Body>
        {children}
        <div className="modal-footer-btn mt-5">
          <button
            type="submit"
            className="red-btn"
            onClick={hideModal}
          >
            {t('closeAUC')}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

FullViewModal.defaultProps = {
  containerClass : "helpTBT"
}

export default FullViewModal;
